import { render, staticRenderFns } from "./CommissioningProtocolDialog.vue?vue&type=template&id=55881134&scoped=true"
import script from "./CommissioningProtocolDialog.vue?vue&type=script&lang=js"
export * from "./CommissioningProtocolDialog.vue?vue&type=script&lang=js"
import style0 from "./CommissioningProtocolDialog.vue?vue&type=style&index=0&id=55881134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55881134",
  null
  
)

export default component.exports